
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as indexO2yMssdNZB7JvMK_45mvXUgoY9Io9CicqZTWvpd69qc_45sMeta } from "/opt/buildhome/repo/node_modules/.pnpm/@una-ui+content@48.3.0_@netlify+blobs@9.1.2_@parcel+watcher@2.5.1_@types+node@22.19.11__9dc049d4e529406bd17655d0053e4735/node_modules/@una-ui/content/pages/index.vue?macro=true";
import { default as _91_46_46_46slug_93kg2ZHfqb4IUlZIIsZlZcT1IxxXqKJavnxa9X_Pv6UqEMeta } from "/opt/buildhome/repo/node_modules/.pnpm/@una-ui+content@48.3.0_@netlify+blobs@9.1.2_@parcel+watcher@2.5.1_@types+node@22.19.11__9dc049d4e529406bd17655d0053e4735/node_modules/@una-ui/content/pages/[...slug].vue?macro=true";
import { default as sidebargGMuzfz3bfafRL8c3pH2Ww81DjZa3X0hQUtVrnidjEYMeta } from "/opt/buildhome/repo/docs/pages/blocks-renderer/sidebar.vue?macro=true";
import { default as collapsible_45nested_45sidebarkdGy_t8q80KRkdo_45DTV3RuW4XjDGABVVkMHA7RLwjxUMeta } from "/opt/buildhome/repo/docs/pages/blocks-renderer/collapsible-nested-sidebar.vue?macro=true";
import { default as blocks_45rendererQpyLHlIujacBR33LkHzkTt4vK9gV8H1gO4iUOUArOesMeta } from "/opt/buildhome/repo/node_modules/.pnpm/@una-ui+content@48.3.0_@netlify+blobs@9.1.2_@parcel+watcher@2.5.1_@types+node@22.19.11__9dc049d4e529406bd17655d0053e4735/node_modules/@una-ui/content/pages/blocks-renderer.vue?macro=true";
export default [
  {
    name: "index",
    path: "/",
    component: () => import("/opt/buildhome/repo/node_modules/.pnpm/@una-ui+content@48.3.0_@netlify+blobs@9.1.2_@parcel+watcher@2.5.1_@types+node@22.19.11__9dc049d4e529406bd17655d0053e4735/node_modules/@una-ui/content/pages/index.vue")
  },
  {
    name: "slug",
    path: "/:slug(.*)*",
    component: () => import("/opt/buildhome/repo/node_modules/.pnpm/@una-ui+content@48.3.0_@netlify+blobs@9.1.2_@parcel+watcher@2.5.1_@types+node@22.19.11__9dc049d4e529406bd17655d0053e4735/node_modules/@una-ui/content/pages/[...slug].vue")
  },
  {
    name: "blocks-renderer",
    path: "/blocks-renderer",
    meta: blocks_45rendererQpyLHlIujacBR33LkHzkTt4vK9gV8H1gO4iUOUArOesMeta || {},
    component: () => import("/opt/buildhome/repo/node_modules/.pnpm/@una-ui+content@48.3.0_@netlify+blobs@9.1.2_@parcel+watcher@2.5.1_@types+node@22.19.11__9dc049d4e529406bd17655d0053e4735/node_modules/@una-ui/content/pages/blocks-renderer.vue"),
    children: [
  {
    name: "blocks-renderer-sidebar",
    path: "sidebar",
    meta: sidebargGMuzfz3bfafRL8c3pH2Ww81DjZa3X0hQUtVrnidjEYMeta || {},
    component: () => import("/opt/buildhome/repo/docs/pages/blocks-renderer/sidebar.vue")
  },
  {
    name: "blocks-renderer-collapsible-nested-sidebar",
    path: "collapsible-nested-sidebar",
    component: () => import("/opt/buildhome/repo/docs/pages/blocks-renderer/collapsible-nested-sidebar.vue")
  }
]
  }
]